export default "__VITE_ASSET__CEZ0JM7u__"